// Module
var code = `<!-- §2 THE CORE — RATIFIED-WD v10 (copy of record 2026-08-13; audit fixes 2026-08-16: #6 payoff line, #9 lossless→complete; payoff C1 pending final confirm) -->
<section class="core-section" aria-labelledby="core-headline">

    <div class="core-section__inner">

        <header class="core-section__header">
            <p class="landing-eyebrow">THE CORE</p>
            <h2 id="core-headline" class="core-section__headline">
                A complete structural language for developers and agents.
            </h2>
            <p class="core-section__lead">
                Captured Behavior &mdash; events and data, wired and declared &mdash; unifies the
                architecture that <span class="core-section__receipt">makes the <strong>Codebase the Spec</strong></span>.
                Every agent, every session, every model reads the same complete definition.
            </p>
            <p class="core-section__payoff">
                No spec required &mdash; applications are written where developers and models work: in the code.
            </p>
        </header>

        <div class="core-section__access">
            <h3 class="core-section__subhead">
                Works with the AI models you already use.
            </h3>
            <p class="core-section__bridge">
                The KB Kit applies your model's fluency to the rules the codebase declares.
            </p>
            <p class="core-section__kit">
                The SpyneJS KB Kit ships inside both application templates &mdash; enterprise tested,
                versioned with every release, read from source. Working instructions for a framework
                models have little to no pre-training on: nothing stale to unlearn, nothing to reconstruct.
            </p>

            <div class="core-section__play">
                <code class="core-section__cmd">npx spyne-cli create-app</code>
                <span class="core-section__play-note">&mdash; then open it. Same workflow, same tools.</span>
            </div>
            <p class="core-section__kicker">
                The language has a spine: <strong>VBL</strong>.
            </p>
        </div>



    </div>

</section>
`;
// Exports
module.exports = code;